module.exports = "/images/vendor/flag-icon-css/flags/4x3/gr.svg?471d733ad436f655210fcb2a9e7d356a";